import type { WidgetSizeEnum } from '@/_schemas/types';
import { type WidgetModelName } from '@/_shared/routes-widgets/configs/permissible-widget-keys';

import type { WidgetConfig } from './types';
import { WIDGET_CONFIG } from './widgets-config';

export const getWidgetByModelName = (modelName: WidgetModelName): WidgetConfig | undefined => {
  return WIDGET_CONFIG[modelName];
};

export const WIDGET_SIZE_MAP: Record<WidgetSizeEnum, string> = {
  small: 'col-span-12 md:col-span-3',
  medium: 'col-span-12 md:col-span-4',
  large: 'col-span-12 md:col-span-6',
  xlarge: 'col-span-12 md:col-span-8',
  full: 'col-span-12',
};
